module.exports = __webpack_public_path__ + "assets/photos/memories/frame-8--97691f5898f6d634ed887191a0458849.jpg";